import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";
import "../style/components/_navigation.scss";

const Navigation = () => {
  // Importation des variables globales
  const { userName, isAdmin, isMJ } = useAuth();
  const [isActive, setIsActive] = useState(false);

  const toggleMenu = () => {
    setIsActive(!isActive);
  };

  return (
    <div className="menu" onClick={toggleMenu}>
      <div
        className={isActive ? "burger active" : "burger"}
        aria-controls="menu"
        aria-expanded="false"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p>Menu</p>
      <ul className={isActive ? "active" : ""}>
        <li>
          <a href="https://le-monde-de-doma.ovh" target="_blank">
            <small>vers </small>Doma
          </a>
        </li>
        {!userName && (
          <>
            <li>
              <NavLink to="/login">Connexion</NavLink>
            </li>
            <li>
              <NavLink to="/signup">Enregistrement</NavLink>
            </li>
            {/* TODO : Remove login fast */}
            <li>
              <NavLink to="/login-fast">Fast</NavLink>
            </li>
          </>
        )}
        {isAdmin && (
          <>
            <li>
              <NavLink to="/admin">Admin</NavLink>
            </li>
            <li>
              <NavLink to="/addxp">XP</NavLink>
            </li>
          </>
        )}
        {userName && (
          <>
            {isMJ && (
              <>
                <li>
                  <NavLink to="/campaigns">Campagnes</NavLink>
                </li>
              </>
            )}
            {!isMJ && (
              <>
                <li>
                  <NavLink to="/characters">Personnages</NavLink>
                </li>
              </>
            )}
            <li>
              <NavLink to="/job">Métiers</NavLink>
            </li>
            <li>
              <NavLink to="/skill">Compétences</NavLink>
            </li>
            <li>
              <NavLink to="/spell">Sorts</NavLink>
            </li>
            <li>
              <NavLink to="/logout">Déconnexion</NavLink>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default Navigation;
